import { render, staticRenderFns } from "./InlineText.vue?vue&type=template&id=f5cc5ad6&scoped=true&"
import script from "./InlineText.vue?vue&type=script&lang=js&"
export * from "./InlineText.vue?vue&type=script&lang=js&"
import style0 from "./InlineText.vue?vue&type=style&index=0&id=f5cc5ad6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cc5ad6",
  null
  
)

export default component.exports